/** @jsx tsx */
import { tsx } from "@dojo/framework/core/vdom";
import { WidgetBase } from "@dojo/framework/core/WidgetBase";
import { STROKE_DASH_MAPPING } from "../../Constants";
import { ISolidFillProperties } from "../interfaces/model/properties/FillProperties";
import { ILineProperties } from "../interfaces/model/properties/LineProperties";

interface IShapePathRenderProps {
    dontDownloadImages?: boolean;
    lineProps: ILineProperties;
    fill: string;
    lineFill: ISolidFillProperties;
    path: string;
    markerHeadID: string;
    markerTailID: string;
    strokeSelect: boolean;
    onpointerdown(event: PointerEvent): void;
    onpointerup(event: PointerEvent): void;
    ondblclick(event: MouseEvent): void;

    onmouseenter?(event: PointerEvent): void;
    onmouseleave?(event: PointerEvent): void;

    highlight?: boolean;
}
/**
 * Widget to render shape path.
 * This re-usable component is responsible to render provided path and provide callback for event handling.
 */
export class ShapePath extends WidgetBase<IShapePathRenderProps> {
	protected render() {
		const dontDownloadImages = this.properties.dontDownloadImages;
		let pointerEvents = "";
		if (dontDownloadImages) {
			pointerEvents = "none";
		} else {
			pointerEvents = this.properties.strokeSelect ? "visible" : "stroke";
		}
		// path stroke
		const stroke = this.properties.lineFill && this.properties.lineFill.color || "none";
		// path stroke width
		const strokeWidth = this.properties.lineProps && this.properties.lineProps.W || 0;
		// path stroke dasharray
		const dash = this.properties.lineProps && this.properties.lineProps.dash || "none";

		return (
			<path
				d={`${this.properties.path}`}
				fill={`${this.properties.fill}`}
				id={`${this.properties.key}`}
				key={`${this.properties.key}`}
				marker-end={this.properties.markerTailID ? `url(#${this.properties.markerTailID})` : null}
				marker-start={this.properties.markerHeadID ? `url(#${this.properties.markerHeadID})` : null}
				ondblclick={this.properties.ondblclick}
				onmouseenter={this.properties.onmouseenter}
				onmouseleave={this.properties.onmouseleave}
				onpointerdown={this.properties.onpointerdown}
				onpointerup={this.properties.onpointerup}
				pointer-events={`${pointerEvents}`}
				stroke={`${stroke}`}
				stroke-dasharray={`${STROKE_DASH_MAPPING[dash]}`}
				stroke-width={`${strokeWidth}`}
				vector-effect="non-scaling-stroke"
			/>
		);
	}
};
